import { CSSProperties, FC, PropsWithChildren, useRef } from 'react'

import { usePinchZoom } from '../../helpers/hooks/usePinchZoom'

import './PinchZoomContainer.scss'

interface PinchZoomContainerProps {
    maxZoom?: number
    className?: string
}

/**
 * Lets users pinch to zoom on its children only, instead of the whole page. Children wider than the container are zoomed
 * out to fit, so give them a fixed width to lay them out at.
 */
const PinchZoomContainer: FC<PropsWithChildren<PinchZoomContainerProps>> = ({
    maxZoom = 2,
    className = '',
    children,
}) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const { zoom, contentWidth, contentHeight } = usePinchZoom(containerRef, contentRef, maxZoom)

    const cssVariables = {
        '--pinch-zoom-zoom': `${zoom}`,
        '--pinch-zoom-content-width': `${contentWidth}`,
        '--pinch-zoom-content-height': `${contentHeight}`,
    } as CSSProperties

    return (
        <div ref={containerRef} style={cssVariables} className={`pinch-zoom-container ${className}`}>
            <div className="pinch-zoom-container__wrapper">
                <div ref={contentRef} className="pinch-zoom-container__content">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default PinchZoomContainer
